<template>
  <t-filter-wrapper :label="label">
    <t-input
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
  </t-filter-wrapper>
</template>

<script>
import TFilterWrapper from './TFilterWrapper.vue';

export default {
  name: 't-filter-search',

  components: {
    TFilterWrapper,
  },

  props: {
    value: {
      type: String,
      required: false,
    },

    label: {
      type: String,
      required: false,
      default: null,
    },

    placeholder: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>
